// Asiakkuus- ja casetyöt. Videot tarjoillaan public/videos -kansiosta,
// jolloin ne eivät kuormita JS-bundlea.
// Elokuva- ja tv-tuotannot eivät kuulu tänne, niillä on oma /film-sivunsa.

// Etusivun (/hetki) nostot tässä järjestyksessä. Muut caset näkyvät vain /tyot-sivulla.
export const featuredIds = ["case-ala-anna-sen-kasvaa", "case-llff-2026-traileri"];

export const projects = {
  upcoming: [],
  completed: [
    {
      id: "case-ala-anna-sen-kasvaa",
      client: "Aseman Lapset × Aivovammaliitto",
      year: "2025",
      headline: ["ÄLÄ ANNA", "SEN KASVAA"],
      subheadline: "Aseman Lapset × Aivovammaliitto · 2025",
      body:
        "Aseman Lapset ry:n ja Aivovammaliiton kampanja nuorten katuväkivaltaa vastaan. Sen ydin on 60 sekunnin filmi väkivallasta ja aivovammoista, joita se aiheuttaa.",
      body2:
        "Käsikirjoitimme, ohjasimme ja tuotimme filmin. Kampanja näkyi ulkomainonnassa, elokuvateattereissa ja Ylen kanavilla. Katselukertoja kertyi yli 7 miljoonaa.",
      media: { type: "video", src: "/videos/aivovammaliitto-ala-anna.mp4" },
    },
    {
      id: "case-sun-effects",
      client: "Sun Effects",
      year: "2025–2026",
      headline: ["SUN EFFECTS", "TOTEUTUKSET 2025–2026"],
      subheadline: "Toteutusten dokumentointi · 2025–2026",
      body:
        "Sun Effects suunnittelee ja toteuttaa valo- ja tilaelämyksiä tapahtumiin. Vuosina 2025–2026 olemme kuvanneet studion toteutuksia lyhyiksi filmeiksi, muun muassa Slushissa, Flow Festivalilla ja Delta Lifessa.",
      body2:
        "Kuvasimme ja ohjasimme filmit ja teimme jälkituotannon Sun Effectsin somekanaviin ja referensseiksi. Kuvat ovat Slush 2025 -toteutuksesta.",
      // Useampi video → karuselli, vaihto nuolilla. Nimet translations.js:n
      // mediaLabels-listasta samassa järjestyksessä.
      media: {
        type: "carousel",
        items: [
          { src: "/videos/sun-effects-slush.mp4" },
          { src: "/videos/sun-effects-delta-life.mp4" },
          { src: "/videos/sun-effects-flow-2026.mp4" },
        ],
      },
      // Kuvagalleria videon ja tekstin jälkeen. Rivit ovat flex-rivejä, joissa
      // kuvan leveys määräytyy kuvasuhteesta (portrait 3/4, landscape 4/3),
      // joten rivin kuvat ovat aina samankorkuisia. Mobiilissa yksi sarake.
      // width/height = tiedoston pikselikoko: selain varaa tilan ennen
      // latausta (ei asettelun hyppyä). Näkyvä koko tulee CSS:stä.
      gallery: [
        [
          { src: "/images/sun-effects-slush-verhot.jpg", width: 1350, height: 1800, ratio: "3 / 4", altKey: 0 },
          { src: "/images/sun-effects-slush-halli.jpg", width: 1800, height: 1350, ratio: "4 / 3", altKey: 1 },
        ],
        [
          { src: "/images/sun-effects-slush-keskustelu.jpg", width: 1800, height: 1350, ratio: "4 / 3", altKey: 2 },
          { src: "/images/sun-effects-slush-valopaneeli.jpg", width: 1350, height: 1800, ratio: "3 / 4", altKey: 3 },
        ],
        [
          { src: "/images/sun-effects-slush-sininen.jpg", width: 1350, height: 1800, ratio: "3 / 4", altKey: 4 },
          { src: "/images/sun-effects-slush-punainen.jpg", width: 1350, height: 1800, ratio: "3 / 4", altKey: 5 },
          { src: "/images/sun-effects-slush-valot.jpg", width: 1800, height: 1350, ratio: "4 / 3", altKey: 6 },
        ],
      ],
    },
    {
      id: "case-kuumaa-maasta-kuuhun",
      client: "Kuumaa",
      year: "2024",
      headline: ["KUUMAA", "MAASTA KUUHUN"],
      subheadline: "Kiertuemainos · 2024",
      body:
        "Kampanjavideo Kuumaa-yhtyeen Maasta kuuhun -kiertueelle. Video yhdistää keikkojen energian ja kappaleen tunnelman, ja se on tehty someen.",
      body2:
        "Ideoimme, kuvasimme ja leikkasimme videon kiertueen markkinointiin ja yhtyeen somekanaviin.",
      media: { type: "video", src: "/videos/kuumaa-maasta-kuuhun.mp4" },
    },
    {
      id: "case-bastard-burgers-birthday",
      client: "Bastard Burgers",
      year: "2024–2026",
      headline: ["BASTARD BURGERS", "SUOMI 2024–2026"],
      subheadline: "Videomarkkinointi · 2024–2026",
      body:
        "Video Bastard Burgersin syntymäpäiväkampanjaan. Se puhuu brändin omalla äänellä ja on tehty someen, jossa ensimmäiset sekunnit ratkaisevat.",
      body2:
        "Konsepti, kuvaus ja jälkituotanto ovat meidän käsialaamme. Video julkaistiin ketjun somekanavissa ja paikallismarkkinoinnissa kampanjan aikana.",
      media: {
        type: "carousel",
        items: [
          { src: "/videos/bastard-burgers-3-years.mp4" },
          // Pystyvideo näytetään 16:9-kehyksessä kokonaan
          { src: "/videos/bastard-burgers-rekry.mp4", ratio: "9 / 16" },
        ],
      },
      gallery: [
        [
          { src: "/images/bastard-burgers-julkisivu.jpg", width: 1350, height: 1800, ratio: "3 / 4", altKey: 0 },
          // Ulkomainonnan dokumentaatio: mykkä pystyvideo kuvien seassa
          { type: "video", src: "/videos/bastard-burgers-outdoor.mp4", ratio: "9 / 16" },
          { src: "/images/bastard-burgers-burgeri-seina.jpg", width: 1200, height: 1800, ratio: "2 / 3", altKey: 1 },
          { src: "/images/bastard-burgers-grilli.jpg", width: 1350, height: 1800, ratio: "3 / 4", altKey: 2 },
        ],
        [
          { src: "/images/bastard-burgers-hana.jpg", width: 1350, height: 1800, ratio: "3 / 4", altKey: 3 },
          { src: "/images/bastard-burgers-kippis.jpg", width: 1200, height: 1800, ratio: "2 / 3", altKey: 4 },
          { src: "/images/bastard-burgers-laatat.jpg", width: 1350, height: 1800, ratio: "3 / 4", altKey: 5 },
          { src: "/images/bastard-burgers-juustotikut.jpg", width: 1350, height: 1800, ratio: "3 / 4", altKey: 6 },
        ],
        [
          { src: "/images/bastard-burgers-jalkapallo.jpg", width: 1350, height: 1800, ratio: "3 / 4", altKey: 7 },
          { src: "/images/bastard-burgers-rappari.jpg", width: 1350, height: 1800, ratio: "3 / 4", altKey: 8 },
          { src: "/images/bastard-burgers-laulaja.jpg", width: 1350, height: 1800, ratio: "3 / 4", altKey: 9 },
          { src: "/images/bastard-burgers-ranskalaiset.jpg", width: 1350, height: 1800, ratio: "3 / 4", altKey: 10 },
        ],
      ],
    },
    {
      id: "case-oatly-kozeen",
      client: "Oatly × Kozeen",
      year: "2025",
      headline: ["OATLY", "× KOZEEN"],
      subheadline: "Brändiyhteistyö · highlight reel · 2025",
      body:
        "Highlight reel Oatlyn ja Kozeenin brändiyhteistyöstä. Kahden brändin yhteinen sävy yhdessä koosteessa.",
      body2:
        "Teimme konseptin, kuvauksen ja jälkituotannon. Video julkaistiin molempien brändien somekanavissa.",
      media: { type: "video", src: "/videos/oatly-kozeen-highlight.mp4" },
    },
    {
      id: "case-lapinlahden-lahde-vuokralaisvideo",
      client: "Lapinlahden Lähde",
      year: "2025",
      headline: ["LAPINLAHDEN", "LÄHDE"],
      subheadline: "Vuokralaisvideo · 2025",
      body:
        "Lapinlahden Lähteellä kohtaavat kulttuuri, mielen hyvinvointi ja yrittäjyys. Vuokralaisvideo esittelee paikan yhteisön ja tilat.",
      body2:
        "Käsikirjoitimme ja kuvasimme videon ja teimme jälkituotannon. Se auttaa löytämään uusia vuokralaisia ja tukee paikan brändityötä.",
      media: { type: "video", src: "/videos/lapinlahden-lahde-vuokralaisvideo.mp4" },
    },
    {
      id: "case-llff-2026-traileri",
      client: "Lapinlahden elokuvajuhlat",
      year: "2026",
      headline: ["LAPINLAHDEN", "ELOKUVAJUHLAT"],
      subheadline: "Festivaalitraileri · 2026",
      body:
        "Traileri Lapinlahden elokuvajuhlien vuoden 2026 festivaalille. Se kutsuu yleisön Lapinlahden Lähteelle ja näyttää, miltä festivaali tuntuu.",
      body2:
        "Osuutemme oli suunnittelu, tuotanto ja jälkituotanto. Traileri julkaistiin festivaalin somekanavissa ja verkkosivuilla.",
      media: { type: "video", src: "/videos/llff-2026-traileri.mp4" },
    },
    {
      // Tapahtumakuvaus: pelkkiä valokuvia, pääkuva 16:9-kehyksessä (3:2-kuva rajautuu hieman)
      id: "case-jonsbok-suurlahetysto",
      client: "Jónsbók",
      year: "2026",
      headline: ["JÓNSBÓK", "ISLANNIN SUURLÄHETYSTÖ"],
      subheadline: "Tapahtumakuvaus · 2026",
      body:
        "Jónsbók on vuonna 2024 Reykjavíkissa perustettu legal tech -yhtiö. Sen tekoälyalusta auttaa juristeja tiedonhaussa, analyysissa ja asiakirjojen laatimisessa.",
      body2:
        "Kuvasimme Jónsbókin tilaisuuden Islannin suurlähetystössä Helsingissä vuonna 2026. Kuvat on tehty Jónsbókin viestintään ja somekanaviin.",
      media: { type: "image", src: "/images/jonsbok-sali.jpg", width: 1800, height: 1200 },
    },
  ],
};
